import React, { Component } from 'react';
import { gsap } from 'gsap';

import { scenesPropTypes } from './prop-types';
import animationData from '../../lotties/2020';
import logo from '../../images/logo-fnr.svg';
import SceneHeading from '../SceneHeading';
import LottiePlayer from '../Players/LottiePlayer';

class Scene0 extends Component {
  constructor(props) {
    super(props);

    /** Parameters */
    this.timeline = null;

    /** Refs */
    this.element = React.createRef();
    this.heading = React.createRef();
    this.tween = React.createRef();
    this.slides = [];
    this.logo = React.createRef();
    this.animation = React.createRef();
  }

  /**
   * Invoked after the component is mounted
   */
  componentDidMount() {
    /** Pause the animation in development environment */
    if (process.env.NODE_ENV === 'development') {
      this.animation.current.pause();
    }

    /** Set up the Scene0 timeline */
    gsap
      .timeline({
        defaults: this.props.params.timelineDefaults,
        scrollTrigger: {
          ...this.props.params.scrollTriggerDefaults,
          trigger: this.element.current,
          end: `=${this.props.params.slideLength}`,
        },
      })
      .to(this.tween.current, { duration: this.props.params.timelineDefaults.duration, width: 0 })
      .to(this.heading.current.element.current, { duration: this.props.params.timelineDefaults.duration / 2, x: -this.element.current.offsetWidth / 2 }, 0)
      .to(this.logo.current, { duration: this.props.params.timelineDefaults.duration / 2, opacity: 0 }, 0);
  }

  render() {
    return (
      <div ref={this.element} className="scene-wrapper">
        <h1 ref={this.logo} className="main-title">
          <img src={logo} alt="Luxembourg National Research Fund" />
        </h1>
        <SceneHeading ref={this.heading} title={this.props.title} icon="arrow-thin-right" />
        <div ref={this.tween} className="scene-animation">
          <LottiePlayer ref={this.animation} play loop animationData={animationData} />
        </div>
      </div>
    );
  }
}

Scene0.propTypes = scenesPropTypes;

export default Scene0;
